// src/pages/services/CustomSolutions.jsx

import ServiceLayout from "../../components/ServiceLayout";
import ServiceFeatureCard from "../../components/ServiceFeatureCard";
import img1 from "../../assets/custom1.jpg";
import img2 from "../../assets/custom2.jpg";
import img3 from "../../assets/custom3.jpg";
import img4 from "../../assets/custom4.jpg";
import img5 from "../../assets/custom5.jpg";
import img6 from "../../assets/custom6.jpg";
import bannerImg from "../../assets/ser4.jpg";
import overviewImg from "../../assets/custom.jpg";
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function CustomSolutions() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  const capabilities = [
    {
      title: "Tailored ERP & CRM",
      description: "Design software systems specifically for your business operations and goals.",
    },
    {
      title: "Cross-Platform Compatibility",
      description: "Deliver apps that run seamlessly on web, desktop, and mobile platforms.",
    },
    {
      title: "Third-Party Integration",
      description: "Integrate APIs and services like payment gateways, SMS, email, and more.",
    },
    {
      title: "Agile & Scalable Design",
      description: "We use agile workflows and scalable architectures that grow with your needs.",
    },
  ];

  const services = [
    {
      title: "Enterprise Software Solutions",
      image: img1,
      description: "Develop secure, scalable enterprise-level software solutions tailored to your organization’s needs.",
    },
    {
      title: "SaaS Development",
      image: img2,
      description: "We create cloud-based SaaS platforms with robust multi-tenant architecture and seamless user experience.",
    },
    {
      title: "POS System Development",
      image: img3,
      description: "Build modern Point of Sale systems for retail, restaurants, or service businesses with inventory and billing integration.",
    },
    {
      title: "API Development & Integration",
      image: img4,
      description: "Create reliable APIs and integrate third-party services to ensure smooth data exchange and interoperability.",
    },
    {
      title: "Custom Web Application Development",
      image: img5,
      description: "Design and build custom web applications for internal operations, client services, or online platforms.",
    },
    {
      title: "Quality Assurance & Testing",
      image: img6,
      description: "Ensure software reliability and performance with our thorough QA testing strategies and automation tools.",
    },
  ];

  return (
    <ServiceLayout
      title="Custom Software Development"
      bannerImg={bannerImg}
      overviewImg={overviewImg}
      overviewHeading="Build software that perfectly fits your unique business needs."
      overviewText="We develop robust, scalable, and secure custom applications tailored specifically to your operations—whether it's ERP systems, productivity tools, or client portals."
      capabilities={capabilities}
      buttonText="Build Your Custom App"
      servicesHeading="Our Custom Software Services"
    >
      <div className="relative px-4 sm:px-6 pb-16">
        <div className="relative flex items-center">
          <button
            onClick={() => scroll("left")}
            className="hidden sm:block absolute left-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronLeft size={40} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scroll-smooth px-4 sm:px-12 scrollbar-hide w-full"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, idx) => (
              <div
                key={idx}
                className="min-w-[300px] max-w-[300px] h-[250px] flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
              >
                <ServiceFeatureCard
                  title={service.title}
                  image={service.image}
                  description={service.description}
                  link="/contact"
                />
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            className="hidden sm:block absolute right-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronRight size={40} />
          </button>
        </div>
      </div>
    </ServiceLayout>
  );
}
